import React from "react";

import { Modal } from "antd";

import { GYNGER_CHECKOUT_PENDING_MESSAGE } from "../hooks/useGyngerCheckoutPayment";
import CheckoutProcessingOverlay from "./CheckoutProcessingOverlay";

import "./CheckoutProcessingModal.css";

export default function CheckoutProcessingModal({
  open,
  message = GYNGER_CHECKOUT_PENDING_MESSAGE,
  onCancelPayment,
  paymentUrl,
}) {
  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      maskClosable={false}
      keyboard={false}
      centered
      destroyOnHidden
      width={480}
      className="CheckoutProcessingModal"
    >
      <CheckoutProcessingOverlay
        open={open}
        message={message}
        onCancelPayment={onCancelPayment}
        paymentUrl={paymentUrl}
        contained
      />
    </Modal>
  );
}
